import { createAsyncThunk } from '@reduxjs/toolkit'
import AssetApiService from '../../services/asset/asset-api-service'
import { ApiAsset } from '../../services/asset/asset-models'

// Load all assets 
export const loadAssetsThunk = createAsyncThunk<ApiAsset[]>(
  'assets/loadAll',
    async () => {
    const pageSize = 1000; // Adjust based on expected max
    const response = await AssetApiService.AssetService.getAssets({ pageSize });
    return response.data; // returns ApiAsset[]
  }
)
